import { library } from '@fortawesome/fontawesome-svg-core';

import CanvasVertical from '@/plugins/fontawesome/CanvasVertical';
import CanvasHorizontal from '@/plugins/fontawesome/CanvasHorizontal';

library.add(CanvasVertical, CanvasHorizontal);
